import {Box, Typography, Link, Stack, useTheme} from '@mui/material';
import {selectUserType} from 'app/store/users/userSlice';
import {LogInType, Release} from 'app/types/Shared';
import {useSelector} from 'react-redux';

export const FooterNav = () => {
  const theme = useTheme();
  const userType = useSelector(selectUserType);
  return (
    <Stack direction='row'>
      <Box padding={1}>
        <Stack direction='row' spacing={2}>
          <Link
            href='https://www.takeda.com/terms-and-conditions/'
            target='_blank'
            underline='none'
            color='black'
            sx={{'&:hover': {color: theme.palette.primary.main}}}
          >
            Terms and Conditions
          </Link>
          <Link
            href='https://www.takeda.com/privacy-notice/'
            target='_blank'
            underline='none'
            color='black'
            sx={{'&:hover': {color: theme.palette.primary.main}}}
          >
            Privacy Notice
          </Link>
          <Link
            href='https://www.takeda.com/cookie-policy/'
            target='_blank'
            underline='none'
            color='black'
            sx={{'&:hover': {color: theme.palette.primary.main}}}
          >
            Cookie Policy
          </Link>
          <Link
            href='https://www.takeda.com/global-accessibility-statement/'
            target='_blank'
            underline='none'
            color='black'
            sx={{'&:hover': {color: theme.palette.primary.main}}}
          >
            Accessibility Statement
          </Link>
          {userType === LogInType.Internal && (
            <Link
              href={Release.notes}
              target='_blank'
              underline='none'
              color='black'
              sx={{'&:hover': {color: theme.palette.primary.main}}}
            >
              ELEVATE Release Notes
            </Link>
          )}
        </Stack>

        <Typography variant='subtitle1' color='black' sx={{pt: 2}}>
          Copyright 1995-2023 Takeda Pharmaceutical Company Limited. All rights reserved.
        </Typography>
      </Box>
    </Stack>
  );
};
